import { reportsMutations } from './reports'

export const localMutationResolvers = {
  ...reportsMutations,
}
